interface ZoneCoverageBarProps {
  percent: number;
  cellsVisited: number;
  cellsTotal: number;
  compact?: boolean;
}

export default function ZoneCoverageBar({ percent, cellsVisited, cellsTotal, compact }: ZoneCoverageBarProps) {
  const clampedPercent = Math.min(100, Math.max(0, percent));
  const barColor = clampedPercent >= 80 ? 'bg-green-500' : clampedPercent >= 50 ? 'bg-yellow-500' : 'bg-primary-500';

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex-1 h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
          <div className={`h-full ${barColor} rounded-full transition-all`} style={{ width: `${clampedPercent}%` }} />
        </div>
        <span className="text-xs text-theme-tertiary tabular-nums">{Math.round(clampedPercent)}%</span>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-medium text-theme-secondary">Coverage</span>
        <span className="text-xs text-theme-tertiary tabular-nums">
          {cellsVisited}/{cellsTotal} cells ({Math.round(clampedPercent)}%)
        </span>
      </div>
      <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div className={`h-full ${barColor} rounded-full transition-all`} style={{ width: `${clampedPercent}%` }} />
      </div>
    </div>
  );
}
